<template>
<div v-if="productsList && productsList.length > 0">
    <hr style='padding-bottom:0; margin-bottom: 0'>
    <div v-for="product in productsList" :key='product.SKU'>
        <div class='top-padding' style="display: inline-block">
            <b-button variant='primary' v-if="product.IsDownload" :href="product.ProductUrl" target="_blank">Related Store Download &raquo;</b-button>
            <b-button variant='primary' v-if="!product.IsDownload" :href="product.ProductUrl" target="_blank">Related Store Product &raquo;</b-button>
        </div>
        <div style="display: inline-block; padding-left: 0.5em;">
            <a :href="product.ProductUrl" target="_blank">{{product.StoreProductTitle}}</a>
        </div>
    </div>
</div>
</template>

<script>
import dataService from '../mixins/dataService.js'
export default {
    mixins: [dataService],
    props: {
        collectionId: {
            type: Number,
            required: false
        },
        daItemId: {
            type: Number,
            required: false
        }
    },
    data: function() {
        return {
            productsList: []
        }
    },
    methods: {
        initializeComponent() {
            if (this.collectionId > 0) {
                this.getDraftBookProducts(this.collectionId).then(resp => {
                    this.productsList = resp.data
                })
            }
            else if (this.daItemId && this.daItemId > 0) {
                this.getDAItemProducts(this.daItemId).then(resp => {
                    this.productsList = resp.data
                })
            }
        }
    },
    watch: {
        'collectionId': function() {
            this.initializeComponent()
        },
        'daItemId': function() {
            this.initializeComponent()
        }
    }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/RelatedStoreProducts.vue